// Stub - not linked yet
export const VeevaPage = () => {
  return (
    <div className="min-h-screen bg-white font-sans flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Veeva Integration
        </h1>
        <p className="text-gray-600">Coming soon</p>
      </div>
    </div>
  );
};
